<h1 mat-dialog-title>Delete module instance?</h1>
<div mat-dialog-content>
  <div class="delete-moi-dialog-content">
    <p>Do you really want to delete this module instance?</p>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close(false)">No</button>
  <button mat-button (click)="close(true)" cdkFocusInitial>Yes</button>
</div>